import { render, staticRenderFns } from "./ScheduleAccordion.vue?vue&type=template&id=1d56aada&scoped=true"
import script from "./ScheduleAccordion.vue?vue&type=script&lang=js"
export * from "./ScheduleAccordion.vue?vue&type=script&lang=js"
import style0 from "./ScheduleAccordion.vue?vue&type=style&index=0&id=1d56aada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56aada",
  null
  
)

export default component.exports